module.exports = __webpack_public_path__ + "static/media/gong.895969ad.mp3";